export default __webpack_public_path__ + "static/media/white-circled-cross.56b21372.svg";